import React, { useState, useEffect } from "react";
import axios from "axios";
import ForecastDay from "./ForecastDay";
import "./App.css";

export default function Forecast(props){

    useEffect(() => {
        setLoaded(false);
    }, [props.coordinates])

    let [loaded, setLoaded] = useState(false);
    let [forecast, setForecast] = useState(null);

    function handleResponse(response){
        setLoaded(true);
        setForecast(response.data.daily);
    }

    if(loaded){
        return(
            <div className="row forecast">
                {forecast.map(function (DailyForecast, index){
                    if(index < 5){
                        return(
                            <ForecastDay key={index} data={DailyForecast}/>
                            )
                    }else{
                        return (" ")
                    }
                })}
            </div>
            
        )
    } else {
        let lat = props.coordinates.latitude;
        let lon = props.coordinates.longitude;
        let apiKey = "3accb3e0a43t5204of065d23ba7a9b14";
        let apiURL =`https://api.shecodes.io/weather/v1/forecast?lat=${lat}&lon=${lon}&key=${apiKey}`;
    
        axios.get(apiURL).then(handleResponse);
    }
    
}